import { useSelector } from "@jti/store/reduxHooks";
import type { LoyaltyCoreReducerType } from "@jti/store/slices/loyaltyCoreSlice";
import type { RootStoreState } from "@jti/store/types";

type UseLoggedUserType = [boolean, LoyaltyCoreReducerType | null, boolean];

const useLoggedUser = (): UseLoggedUserType => {
  const { isLogged, isLoaded } = useSelector((state: RootStoreState) => state.loyaltyCore);
  const user = useSelector((state: RootStoreState) => state.loyaltyCore);

  return [isLogged, isLogged ? user : null, isLoaded];
};

export default useLoggedUser;
